import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BlogSidebar from "../BlogSidebar/BlogSidebar.js";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useIsCourseHaveStudentMutation } from "../../api/studentCourseApi.js";
import { Button } from "reactstrap";
import { calculateAverageRating } from "../../Helpers/calculateAverageRating";
import { useTranslation } from "react-i18next";
import './Styles/BlogList.css'
const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const BlogList = (props) => {
  const { t } = useTranslation();
  const { i18 } = useTranslation();
  const [pageCounter, setPageCounter] = useState(0);

  const [GetMyCourses] = useIsCourseHaveStudentMutation();
  const [myCourse, setMyCourse] = useState();
  const [filter, setFilter] = useState({
    isSearch: true,
    pageIndex: 1,
    pageSize: 6,
    sortColumn: "CreatedDate",
    sortOrder: "desc",
    filters: {
      groupOp: "AND",
      rules: [
        {
          field: "UserId",
          op: 1,
          data: "",
        },
      ],
    },
  });

  useEffect(() => {
    const getMyCourses = async () => {
      try {
        await GetMyCourses(filter).then((response) => {
          setPageCounter(response.data.result.paginationCounter);
          setMyCourse(response.data.result.data)
        });
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    getMyCourses();
  }, [filter]);

  const handleClickChangePageNumber = (clickedPageNumber) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageIndex: clickedPageNumber,
    }));
  };

  return (
    <section className="modern-my-courses-section">
      <div className="modern-courses-container">
        <div className="courses-grid">
          {myCourse && myCourse.length > 0 ?
            myCourse.map((course, key) => (
              <Link
                onClick={ClickHandler}
                to={`/course-single/${course.courseId}`}
                key={key}
                className="modern-course-card"
              >
                <div className="course-card-inner">
                  <div className="course-image-wrapper">
                    <img src={course.courseImage} alt={course.courseName} />
                    <div className="course-overlay">
                      <div className="overlay-content">
                        <i className="fi flaticon-eye"></i>
                        <span>{t("View Course")}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="course-content">
                    <div className="course-header">
                      <div className="course-rating">
                        <i className="fi flaticon-star"></i>
                        <span className="rating-value">{calculateAverageRating(course.ratings)}</span>
                      </div>
                      <div className="course-author-badge">
                        <img src={course.author} alt="Author" />
                      </div>
                    </div>
                    
                    <h3 className="course-title">{course.courseName}</h3>
                    
                    <div className="course-stats">
                      <div className="stat-item">
                        <i className="fi flaticon-reading-book"></i>
                        <span>{course.student} {t("Students")}</span>
                      </div>
                      <div className="stat-item">
                        <i className="fi flaticon-agenda"></i>
                        <span>{course.lesson} {t("Lesson")}</span>
                      </div>
                    </div>
                    
                    <div className="course-footer">
                      <button className="continue-btn">
                        <span>{t("Continue Learning")}</span>
                        <i className="fi flaticon-next"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </Link>
            )) : (
              <div className="my-courses-empty-state">
                <div className="my-courses-empty-mark" aria-hidden="true" />
                <h3>{t("Henüz kursunuz yok")}</h3>
                <p>{t("Satın aldığınız veya kaydolduğunuz kurslar burada listelenecek.")}</p>
                <Link to="/home" className="my-courses-empty-link" onClick={ClickHandler}>
                  {t("Kursları keşfet")}
                </Link>
              </div>
            )}
        </div>
        
        {/* Modern Pagination */}
        <div className="modern-pagination">
          {filter.pageIndex != 1 && (
            <button
              className="pagination-btn prev-btn"
              onClick={() => {
                handleClickChangePageNumber(filter.pageIndex - 1);
                window.scrollTo(0, 0);
              }}
            >
              <i className="fi flaticon-back"></i>
              <span>{t("Previous")}</span>
            </button>
          )}
          
          <div className="pagination-numbers">
            {[...Array(pageCounter)].map((_, index) => (
              <button
                key={index}
                className={`page-number ${filter.pageIndex === index + 1 ? 'active' : ''}`}
                onClick={() => {
                  handleClickChangePageNumber(index + 1);
                  window.scrollTo(15, 15);
                }}
              >
                {index + 1}
              </button>
            ))}
          </div>
          
          {filter.pageIndex != pageCounter && (
            <button
              className="pagination-btn next-btn"
              onClick={() => {
                handleClickChangePageNumber(filter.pageIndex + 1);
                window.scrollTo(0, 0);
              }}
            >
              <span>{t("Next")}</span>
              <i className="fi flaticon-next"></i>
            </button>
          )}
        </div>
      </div>
    </section>
  
  
  );
};

export default BlogList;
